(function () {
    'use strict';

    angular.module("imApp").factory("serviceObjectTypesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1738,
                    parameters: parms || {}
                });
            },
            listServiceObjectTypes: function (parms) {
                return $ihttp.post({
                    method: 1739,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
